import { render } from "./VsSelect.vue?vue&type=template&id=9f481bd0"
import script from "./VsSelect.vue?vue&type=script&lang=js"
export * from "./VsSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__